export default __webpack_public_path__ + "static/media/ff_en_1.7e1f1a64.png";